import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetAppraisalByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  customer_id: Types.Scalars['bigint']['input'];
}>;


export type GetAppraisalByIdQuery = { __typename?: 'query_root', appraisals: Array<{ __typename?: 'appraisals', id: number, customer_id?: number | null, status: string, vin: string, vehicle_data?: object | null, condition: string, trim_overrides?: object | null, mileage_override?: number | null, value_type: string, value_total: number, value_adjustment: number, vehicle_notes?: string | null, favorite: boolean, last_fetch_time_utc: string, last_save_time_utc: string, appraiser_name?: string | null, appraiser_credentials?: string | null, appraiser_contact?: string | null, appraiser_notes?: string | null, appraiser_expire_time_utc?: string | null, customer?: { __typename?: 'customers', id: number, name?: string | null, phone?: string | null } | null, moves: Array<{ __typename?: 'moves', id: number, customer_id?: number | null, pickup_stop_id?: string | null, delivery_stop_id?: string | null, status?: string | null, pickup_time?: string | null, ready_by?: string | null, vehicle_year?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_color?: string | null, vehicle_odometer?: string | null, consumer_name?: string | null, consumer_phone?: string | null, pickup_workflow_data?: object | null, delivery_workflow_data?: object | null, lane?: { __typename?: 'lanes', id: number, description?: string | null } | null, vehiclephotos: Array<{ __typename?: 'vehiclephotos', step_id: string, workflow_id: number, url?: string | null, name: string, workflow: { __typename?: 'workflows', type: string } }> }> }> };


export const GetAppraisalByIdDocument = gql`
    query getAppraisalById($id: bigint!, $customer_id: bigint!) {
  appraisals(where: {id: {_eq: $id}, customer_id: {_eq: $customer_id}}) {
    id
    customer_id
    status
    vin
    vehicle_data
    condition
    trim_overrides
    mileage_override
    value_type
    value_total
    value_adjustment
    vehicle_notes
    favorite
    last_fetch_time_utc
    last_save_time_utc
    appraiser_name
    appraiser_credentials
    appraiser_contact
    appraiser_notes
    appraiser_expire_time_utc
    customer {
      id
      name
      phone
    }
    moves(
      limit: 50
      where: {active: {_eq: 1}, move_type: {_eq: "drive"}, customer_id: {_eq: $customer_id}}
      order_by: {ready_by: desc_nulls_last, id: desc_nulls_last}
    ) {
      id
      customer_id
      pickup_stop_id
      delivery_stop_id
      status
      pickup_time
      ready_by
      vehicle_year
      vehicle_make
      vehicle_model
      vehicle_color
      vehicle_odometer
      consumer_name
      consumer_phone
      pickup_workflow_data
      delivery_workflow_data
      lane {
        id
        description
      }
      vehiclephotos {
        step_id
        workflow_id
        url
        name
        workflow {
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetAppraisalByIdQuery__
 *
 * To run a query within a React component, call `useGetAppraisalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppraisalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppraisalByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      customer_id: // value for 'customer_id'
 *   },
 * });
 */
export function useGetAppraisalByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables> & ({ variables: GetAppraisalByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>(GetAppraisalByIdDocument, options);
      }
export function useGetAppraisalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>(GetAppraisalByIdDocument, options);
        }
// @ts-ignore
export function useGetAppraisalByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>;
export function useGetAppraisalByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppraisalByIdQuery | undefined, GetAppraisalByIdQueryVariables>;
export function useGetAppraisalByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>(GetAppraisalByIdDocument, options);
        }
export type GetAppraisalByIdQueryHookResult = ReturnType<typeof useGetAppraisalByIdQuery>;
export type GetAppraisalByIdLazyQueryHookResult = ReturnType<typeof useGetAppraisalByIdLazyQuery>;
export type GetAppraisalByIdSuspenseQueryHookResult = ReturnType<typeof useGetAppraisalByIdSuspenseQuery>;
export type GetAppraisalByIdQueryResult = Apollo.QueryResult<GetAppraisalByIdQuery, GetAppraisalByIdQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appraisals/queries/getAppraisalById.query.gql}
 */
export async function getAppraisalById(
  variables: GetAppraisalByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetAppraisalByIdQuery['appraisals']>
export async function getAppraisalById(
  variables: GetAppraisalByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetAppraisalByIdQuery>
export async function getAppraisalById(
  variables: GetAppraisalByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetAppraisalByIdQuery['appraisals'] | GetAppraisalByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetAppraisalByIdQuery>(
    GetAppraisalByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.appraisals
}